import * as React from "react";
import videos from "url:../../videos/*.mp4";
import "../../css/opacity.css";
import { researchData } from "../data";
import { getLocalizedText } from "../util";
import { getAssetUrl, resolveAssetMap } from "../asset";
import { useLang } from "../lang";

const Research: React.FC = () => {
  const { langEn } = useLang();
  const videoMap = resolveAssetMap(videos);
  return (
    <div id="research" className="container justify-content-center mb-4">
      <p className="title">{langEn ? "Research Questions" : "リサーチ・クエスチョン"}</p>

      <div className="row text-left">
        {researchData.map((study, i) => (
          <div key={i} className="col-md-12 panel-group">
            <p className="sub-title panel-heading">
              {study.past ? (
                <a data-toggle="collapse" href={"#study-" + i}>
                  &raquo;{" "}
                  {langEn
                    ? getLocalizedText(study.title, true) + " (past)"
                    : getLocalizedText(study.title, false) + " (過去)"}
                </a>
              ) : langEn ? (
                getLocalizedText(study.title, true)
              ) : (
                getLocalizedText(study.title, false)
              )}
            </p>

            <div className={"panel-collapse" + (study.past ? " collapse" : "")} id={"study-" + i}>
              <div className="pl-10 pr-10 mb-3">{getLocalizedText(study.description, langEn)}</div>

              <div className="row">
                {(study.gif ?? []).map((item, j) => (
                  <div className="col-md-4 mb-1 text-center" key={j}>
                    {(() => {
                      const videoUrl = getAssetUrl(videoMap, item.src);
                      return videoUrl ? <video src={videoUrl} autoPlay loop muted /> : "";
                    })()}
                    <p className="text-center">
                      <small>{getLocalizedText(item.title, langEn)}</small>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Research;
